import { StyleSheet } from 'react-native';

import { heightPercentageToDP, isTabletOrWeb } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        alignSelf: isTabletOrWeb ? 'flex-start' : 'center',
        height: 32,
        marginBottom: heightPercentageToDP(8),
    },
    text: {
        lineHeight: 24,
        marginBottom: heightPercentageToDP(8),
        fontSize: 24,
    },
});

export default styles;
